export default "__VITE_ASSET__mzdWmYKB__"